import find from 'lodash/find';
import { countryCodeToCurrency, currencyToDcimals } from '../constants/currencyCodes';

const newCurrencyFormatter = (locale, currencyCode) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  });

export const currencyCodeToSymbol = (currencyCode, locale) => {
  const localeToFormatTo = locale.replace('_', '-');
  const currencyFormatter = newCurrencyFormatter(localeToFormatTo, currencyCode);
  const currencyParts = currencyFormatter.formatToParts(0);
  const currencySymbolPart = find(currencyParts, { type: 'currency' });
  const currencySymbol = currencySymbolPart.value;
  return currencySymbol;
};

export const formatCurrencyValue = ({ value, locale, currencyCode }) => {
  const [languageCode, countryCode] = locale.split('_');
  const currencyFormatter = newCurrencyFormatter(
    `${languageCode}-${countryCode}`,
    currencyCode || countryCodeToCurrency[countryCode],
  );
  return currencyFormatter.format(value);
};

export const mapCostsFromWholeToDecimalUnits = (costs) => {
  const fractionDigits =
    typeof currencyToDcimals[costs.currency_code] === 'number'
      ? currencyToDcimals[costs.currency_code]
      : 2;
  return Object.entries(costs).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: typeof value === 'number' ? value / 10 ** fractionDigits : value,
    }),
    {},
  );
};

export const getCurrencyDP = (currency = 'USD') => {
  const mapping = {
    BHD: 3,
    BIF: 0,
    CLF: 4,
    CLP: 0,
    DJF: 0,
    GNF: 0,
    IQD: 3,
    ISK: 0,
    JOD: 3,
    JPY: 0,
    KMF: 0,
    KRW: 0,
    KWD: 3,
    LYD: 3,
    OMR: 3,
    PYG: 0,
    RWF: 0,
    TND: 3,
    UGX: 0,
    UYI: 0,
    UYW: 4,
    VND: 0,
    VUV: 0,
    XAF: 0,
    XOF: 0,
    XPF: 0,
  };
  return mapping[currency] || 2;
};

export const getCurrencyExponent = (currency = 'USD') => 10 ** getCurrencyDP(currency);
